<template>
  <div class="l-content-inner">
    <!-- 에러페이지(기타) -->
    <div class="p-system-wrap">
      <div class="logo-box">
        <a
          href="javascript:void(0);"
          @click="btnCmd('goHome')"
          title="noroo 홈으로 이동"
        >
          <img src="@/assets/images/common/logo_noroo.svg" alt="NOROO" />
        </a>
        <a
          href="javascript:void(0);"
          @click="btnCmd('goHome')"
          title="noroo paint pro 홈으로 이동"
        >
          <img
            src="@/assets/images/common/logo_noroo_paintpro.svg"
            alt="PAINT PRO"
          />
        </a>
      </div>
      <div class="c-status-wrap">
        <div class="icon-box">
          <i class="c-icon icon-nodata size-large"></i>
        </div>
        <div class="text">
          <strong class="c-title-level3">
            요청하신 서비스를 진행할 수 없습니다.
          </strong>
          <p class="sub-text">
            이용에 불편을 드려 죄송합니다.<br />
            잠시 후 다시 접속해 주세요.
          </p>
        </div>
      </div>
      <div class="navigation-box">
        <a
          href="javascript:void(0);"
          @click="btnCmd('goBack')"
          class="btn-back"
        >
          <i class="c-icon icon-arrow-left-green"></i>
          뒤로가기
        </a>
        <a
          href="javascript:void(0);"
          @click="btnCmd('goHome')"
          class="btn-home"
        >
          홈으로 가기
          <i class="c-icon icon-arrow-right-green"></i>
        </a>
      </div>
    </div>
    <!-- // 에러페이지(기타) -->
  </div>
</template>
<script setup name="error500">
import { useRouter } from "vue-router";
const router = useRouter();
/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "goBack") {
    if (window.history.length > 1) {
      window.history.back(); // 브라우저 히스토리가 1보다 크면 이전 페이지로 돌아감
    } else {
      router.push("/"); // 히스토리가 없으면 특정 페이지로 리디렉션 (예: 홈 페이지)
    }
  } else if (cmd === "goHome") {
    location.href = "/paintpro/main";
  } else {
    alert(
      `[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` +
        JSON.stringify(parms, null, " ")
    );
    return false;
  }
}
</script>
